const tools = require('../../tools')

exports.listWarehouseCodes = async function (state, locationDoc) {
  const prefix = tools.getPSMCodePrefix(locationDoc.location)
  return state.dal.location.listWarehouseCodes(state, prefix)
}
